import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const _moneyFmt = new Intl.NumberFormat("hr-HR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function formatMoney(n) {
  const num = Number(n);
  return _moneyFmt.format(Number.isFinite(num) ? num : 0);
}

